export default {
	path: 'accessLogs',
	name: 'AccessLogForm',
	component() {
		return import('@/components/accessLog/AccessLogForm.vue')
	},
	children: [
		{
			path: '',
			name: 'AccessLogList',
			component() {
				return import('@/components/accessLog/AccessLogList.vue')
			},
		},
	],
}